// action 类型定义
const UseForm_ACTION_TYPE = {
  SET_DATA: 'SET_DATA_FORMSTATE', // 设置数据
  SETDisabledAll: 'setDisabledAll_FORMSTATE', // 禁用全部
  INIT_FORMSTATE: 'init_formstate', // 表单数据默认
}
export interface formState {
  key: string
  hidden?: boolean // 隐藏
  disabled?: boolean // 禁用
}
// 当前状态接口
export interface UseFormState {
  FormState: formState[]
}

// 默认数据
const defaultState: UseFormState = {
  FormState: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case UseForm_ACTION_TYPE.INIT_FORMSTATE:
      arr.FormState = []
      return arr
    case UseForm_ACTION_TYPE.SET_DATA:
      const a = action.value.map((item: any) => item.key)
      // 先过滤已有的数据
      const newa = arr.FormState.filter((item) => a.indexOf(item.key) === -1)
      // 合并最新的数据
      arr.FormState = [...newa, ...action.value]
      return arr
    case UseForm_ACTION_TYPE.SETDisabledAll:
      arr.FormState = arr.FormState.map((item) => ({
        ...item,
        ...{ disabled: true },
      }))
      return arr
    default:
      return state
  }
}

// 初始化数据
export const setformStateInitAction = () => ({
  type: UseForm_ACTION_TYPE.INIT_FORMSTATE,
})

// 设置数据
export const setformStateAction = (param: formState[]) => ({
  type: UseForm_ACTION_TYPE.SET_DATA,
  value: param,
})

// 设置全部禁用
export const setformAllStateAction = (param: boolean) => ({
  type: UseForm_ACTION_TYPE.SETDisabledAll,
  value: param,
})
// action 类型定义
const UseForm_ACTION_TYPE = {
  SET_DATA: 'SET_DATA_FORMSTATE', // 设置数据
  SETDisabledAll: 'setDisabledAll_FORMSTATE', // 禁用全部
  INIT_FORMSTATE: 'init_formstate', // 表单数据默认
}
export interface formState {
  key: string
  hidden?: boolean // 隐藏
  disabled?: boolean // 禁用
}
// 当前状态接口
export interface UseFormState {
  FormState: formState[]
}

// 默认数据
const defaultState: UseFormState = {
  FormState: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case UseForm_ACTION_TYPE.INIT_FORMSTATE:
      arr.FormState = []
      return arr
    case UseForm_ACTION_TYPE.SET_DATA:
      const a = action.value.map((item: any) => item.key)
      // 先过滤已有的数据
      const newa = arr.FormState.filter((item) => a.indexOf(item.key) === -1)
      // 合并最新的数据
      arr.FormState = [...newa, ...action.value]
      return arr
    case UseForm_ACTION_TYPE.SETDisabledAll:
      arr.FormState = arr.FormState.map((item) => ({
        ...item,
        ...{ disabled: true },
      }))
      return arr
    default:
      return state
  }
}

// 初始化数据
export const setformStateInitAction = () => ({
  type: UseForm_ACTION_TYPE.INIT_FORMSTATE,
})

// 设置数据
export const setformStateAction = (param: formState[]) => ({
  type: UseForm_ACTION_TYPE.SET_DATA,
  value: param,
})

// 设置全部禁用
export const setformAllStateAction = (param: boolean) => ({
  type: UseForm_ACTION_TYPE.SETDisabledAll,
  value: param,
})
